
import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormHelperText, InputLabel, TextField } from '@material-ui/core';

import { AutocompleteWrapper, AlertWrapper } from 'src/components';


const SmaMonitoringPlanForm = ({ actions, validations, options, data }) => {
  const { handleMonitoringPlanName, handleSiteChange } = actions;
  const { hasError, hasName, hasBadData, errorMessage } = validations;
  const { sitesOptions } = options;
  const { monitoringPlanName, site } = data;

  return (
    <Box p={1}>
      <Box my={3}>
        <InputLabel required shrink>Nombre</InputLabel>
        <TextField
          value={monitoringPlanName}
          onChange={e => handleMonitoringPlanName(e.target.value)}
          fullWidth
          autoFocus
          required
          autoComplete="off"
          variant="outlined"
          size="small"
          placeholder="Ej: Plan de monitoreo de vachellia caven"
        />
        {hasBadData && !hasName && <FormHelperText error>El nombre es obligatorio</FormHelperText>}
      </Box>
      <Box my={3}>
        <InputLabel shrink>Sitio</InputLabel>
        <AutocompleteWrapper
          options={sitesOptions}
          getOptionSelected={(option, value) => option.value === value?.value}
          onChange={handleSiteChange}
          value={site}
        />
      </Box>
      {hasError && <AlertWrapper severity="error">{errorMessage}</AlertWrapper>}
    </Box>
  );
};

SmaMonitoringPlanForm.propTypes = {
  actions: PropTypes.shape({
    handleMonitoringPlanName: PropTypes.func.isRequired,
    handleSiteChange: PropTypes.func.isRequired,
  }),
  data: PropTypes.shape({
    site: PropTypes.object,
    monitoringPlanName: PropTypes.string,
  }),
  validations: PropTypes.shape({
    hasError: PropTypes.bool,
    errorMessage: PropTypes.string,
    hasName: PropTypes.bool,
    hasBadData: PropTypes.bool,
  }),
  options: PropTypes.shape({
    sitesOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
};


export { SmaMonitoringPlanForm };
